import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
} from "firebase/storage";
import { db, storage } from "../firebase/config";

const GALLERY_COLLECTION = "galleryImages";

export const subscribeToGallery = (onChange) => {
  if (!db) {
    onChange([]);
    return () => {};
  }
  const galleryQuery = query(
    collection(db, GALLERY_COLLECTION),
    orderBy("createdAt", "desc"),
  );
  return onSnapshot(galleryQuery, (snapshot) => {
    const images = snapshot.docs.map((item) => ({
      id: item.id,
      ...item.data(),
    }));
    onChange(images);
  });
};

export const uploadGalleryImage = async ({
  file,
  titleHindi,
  titleEnglish,
  featured,
}) => {
  if (!db || !storage) {
    throw new Error("Firebase storage is not configured.");
  }
  const storagePath = `gallery/${Date.now()}_${file.name}`;
  const fileRef = ref(storage, storagePath);
  const uploadResult = await uploadBytes(fileRef, file);
  const downloadUrl = await getDownloadURL(uploadResult.ref);

  const docRef = await addDoc(collection(db, GALLERY_COLLECTION), {
    titleHindi,
    titleEnglish,
    visible: true,
    featured: Boolean(featured),
    downloadUrl,
    storagePath,
    createdAt: serverTimestamp(),
  });

  return docRef.id;
};

export const updateGalleryImage = async (id, updates) => {
  if (!db) {
    throw new Error("Firebase database is not configured.");
  }
  await updateDoc(doc(db, GALLERY_COLLECTION, id), updates);
};

export const removeGalleryImage = async (id, storagePath) => {
  if (!db) {
    throw new Error("Firebase database is not configured.");
  }
  await deleteDoc(doc(db, GALLERY_COLLECTION, id));
  if (storagePath) {
    if (!storage) {
      throw new Error("Firebase storage is not configured.");
    }
    await deleteObject(ref(storage, storagePath));
  }
};
